import React from "react";
import styles from "./styles";

// MATERIAL UI
import { withStyles } from "@mui/styles";
import {
  Slide,
  Grid,
  Typography,
  InputBase,
  Box,
  DialogContent,
  Dialog,
} from "@mui/material/";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class DialogQuestions extends React.Component {
  render() {
    const {
      classes,
      palabras,
      selected,
      solution,
      answer,
      textInput,
      open,
      handleCloseDialog,
    } = this.props;
    return (
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        style={{ borderRadius: "20px" }}
        disableScrollLock
      >
        <DialogContent>
          <Grid
            spacing={1}
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{
              backgroundColor: "#fff",
              padding: "3% 0",
            }}
          >
            <Grid item xs={12} sm={4}>
              <Box display="flex" justifyContent="center">
                <table>
                  <tbody>
                    <tr>
                      <td className={classes.answer}>
                        {selected !== undefined
                          ? `${palabras[selected].palabra.substring(0, 1)}`
                          : null}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box display="column" flexDirection="row" justifyContent="center">
                <Typography
                  variant="h4"
                  color="textPrimary"
                  style={{ fontWeight: "bold", margin: "0 0 3px 0" }}
                >
                  Pista:
                </Typography>
                <Typography
                  variant="body2"
                  color="textPrimary"
                  style={{
                    fontWeight: "bold",
                    color: "#7d7d7d",
                  }}
                >
                  {selected !== undefined
                    ? `${palabras[selected].pista}`
                    : null}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography
                color="textPrimary"
                variant="h4"
                style={{
                  fontWeight: "bold",
                  color: "#7f0101",
                  margin: "0 0 3px 0",
                }}
              >
                {selected !== undefined
                  ? `${palabras[selected].palabra.length} Letras:`
                  : null}
              </Typography>
              <InputBase
                className={classes.inputbase}
                placeholder="Escribe aquí respuesta"
                inputProps={{
                  "aria-label": "naked",
                  style: { textAlign: "center", fontWeight: "bold" },
                }}
                inputRef={textInput}
                onChange={(event) =>
                  selected !== undefined ? solution(event.target.value) : null
                }
                value={answer}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(DialogQuestions);
